import React from 'react';
import { Button, Form, Table } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { RISK_RETURN_EXPECTATION } from "../../../utils/constants";

const ProposedPortfolio = ({
    nextStep,
    prevStep,
    handleSubmit,
    active,
    expectation,
    hasPlaidAccountConnected
}) => {

    const handleNext = (formData) => {
        nextStep(formData, hasPlaidAccountConnected ? 1 : 0);
    };

    const handleBack = () => {
        prevStep();
    }

    let portfolioItems = RISK_RETURN_EXPECTATION[expectation] || [];
    portfolioItems = portfolioItems.filter(item => item.target !== '0%');

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>PROPOSED PORTFOLIO</h2>
                    <span>Based on your risk appetite, we will invest you in:</span>
                </div>
                <div className="account-info-container">
                    <Table striped>
                        <thead>
                            <tr>
                                <th className="text-center">Target(%)</th>
                                <th>Ticker</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                portfolioItems.map((item, key) => (
                                    <tr key={key}>
                                        <th scope="row">{item.target}</th>
                                        <td>
                                            {
                                                item.ticker === 'SPTM' ?
                                                    (
                                                        <a href="https://www.sec.gov/Archives/edgar/data/1064642/000119312519317506/d878044d497k.htm"
                                                            target="_blank" rel="noopener noreferrer">{item.ticker}</a>
                                                    ) : item.ticker
                                            }
                                        </td>
                                        <td>{item.description}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit">
                        NEXT QUESTION
                    </button>
                </div>
            </Form>
        </div>
    )
};

export default reduxForm({
    form: 'ProposedPortfolioForm',
})(ProposedPortfolio);
